import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import Popover from '@material-ui/core/Popover';
import {CURSOR} from '../../../styles/fonts/MCFontConstants';
import {
    ContentContainer,
    CalendarPanelHeader,
} from 'src/pages/home/component/calendarPanel/Panel.Styled';

export const Title = styled.h2`
    font-family: 'AvenirNextWorld Demi';
    margin: 0;
    color: #140f4b;
    ${media.mobileDevice`     
        color: #ffffff;        
    `}
    @media only screen and (max-device-width: 390px) {
        font-size: 22px;
    }
    @media only screen and (max-device-width: 360px) {
        font-size: 21px;
    }
`;

export const PhysicianPanelHeader = styled(CalendarPanelHeader)`
    ${media.mobileDevice`
        z-index:2000;
    `}
`;

export const PhysicianContentContainer = styled(ContentContainer)`
    padding: 10px 0 5px 0;
    ${media.mobileDevice`
        padding: 6px 0.95rem 6px 0.95rem;   
    `}
`;

export const FilterPopover = styled(Popover)`
    & .MuiPaper-root {
        top: 130px !important;
    }
    ${media.mobileDevice`
        & .MuiPaper-root{
            top: 0 !important;
            left:0 !important;
        }
        & .MuiPopover-paper{
            max-width: 100vw;
            max-height: 100vh;
            transition: all 100ms ease-in-out !important;
        }
    `}
`;
export const Icon = styled.div`
    background: url(${(props) => props.deskPath});
    width: 100%;
    height: 100%;
    cursor: ${CURSOR};
    ${media.mobileDevice`
    background: url(${(props) => props.mobilePath});
    opacity: ${(props) => (props.adminSearchOpen ? '0' : '1')}
    `}
`;

export const FilterContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    margin: 0px -1px 1px auto;
    ${media.mobileDevice`
    margin:1px -8px 0px auto;
    `};
`;
export const HeaderContainer = styled.div`
    margin-bottom: 25px;
    ${media.mobileDevice`
        display:flex;
        justify-content: center;
        margin-bottom: ${(props) =>
            props.adminSearchOpen ? '30px' : '5px'};

        background-color: ${(props) =>
            props.theme.calendarBackgroundColor} !important;
    `}
`;
